import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=66c1a352&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=66c1a352&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1a352",
  null
  
)

export default component.exports